import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ImportantInfo() {
  const nav = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white text-[#0A0B0D] max-w-2xl mx-auto pb-32" data-testid="important-info-page">
      <div className="sticky top-0 z-30 bg-white border-b border-[#E2DFD4]">
        <div className="flex items-center gap-2 px-5 py-5">
          <button onClick={() => nav(-1)} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full hover:bg-[#F4F1E8]" data-testid="important-info-back" aria-label="Back">
            <ArrowLeft className="w-7 h-7" strokeWidth={3} />
          </button>
          <h1 className="font-display font-black text-[20px] sm:text-[24px] tracking-tight">{t("important.title")}</h1>
        </div>
      </div>

      <div className="px-5 pt-6 space-y-5 text-sm leading-relaxed text-[#3D424B]">
        <p className="font-bold text-sm text-[#0A0B0D]">
          {t("important.welcome")}
        </p>

        <div className="p-5 bg-[#FFE6E0] border-2 border-[#FF7A6B] rounded-2xl space-y-3 shadow-nb-sm">
          <div className="flex items-center gap-2 text-[#D14848] font-display font-black text-base">
            <span className="text-xl">⚠️</span> {t("important.deletionTitle")}
          </div>
          <p className="text-xs text-[#3D424B] leading-relaxed">{t("important.deletionIntro")}</p>
          <p className="font-bold text-xs text-[#D14848]">{t("important.deletionWarning")}</p>
          <ul className="list-disc pl-5 space-y-1 text-xs text-[#3D424B]">
            <li>{t("important.deletionBullet1")}</li>
            <li>{t("important.deletionBullet2")}</li>
          </ul>
          <div className="pt-2 border-t border-[#FF7A6B]/30">
            <p className="font-display font-black text-xs text-[#D14848] uppercase tracking-wider mb-1">{t("important.noRefunds")}</p>
            <p className="text-xs text-[#3D424B] leading-relaxed font-semibold">{t("important.noRefundsDetail")}</p>
          </div>
        </div>

        <div className="p-4 bg-[#FFF1D6] border border-[#F9C349] rounded-2xl space-y-2">
          <h3 className="font-display font-black text-base text-[#0A0B0D]">{t("important.cashoutTitle")}</h3>
          <p className="text-xs text-[#3D424B]">{t("important.cashoutIntro")}</p>
          <ul className="list-disc pl-5 space-y-1.5 text-xs text-[#3D424B]">
            <li><span className="font-bold text-[#0A0B0D]">{t("important.cashoutFeeLabel")}</span> {t("important.cashoutFeeText")}</li>
            <li><span className="font-bold text-[#0A0B0D]">{t("important.cashoutAccuracyLabel")}</span> {t("important.cashoutAccuracyText")}</li>
            <li><span className="font-bold text-[#0A0B0D]">{t("important.cashoutTimeLabel")}</span> {t("important.cashoutTimeText")}</li>
          </ul>
        </div>

        <div className="p-4 bg-[#ECE6FF] border border-[#A78BFA] rounded-2xl space-y-2">
          <h3 className="font-display font-black text-base text-[#0A0B0D]">{t("important.giftingTitle")}</h3>
          <p className="text-xs text-[#3D424B]">{t("important.giftingIntro")}</p>
          <ul className="list-disc pl-5 space-y-1.5 text-xs text-[#3D424B]">
            <li><span className="font-bold text-[#0A0B0D]">{t("important.giftingFeeLabel")}</span> {t("important.giftingFeeText")}</li>
            <li><span className="font-bold text-[#0A0B0D]">{t("important.giftingExampleLabel")}</span> {t("important.giftingExampleText")}</li>
          </ul>
        </div>

        <div className="p-4 bg-[#DEF1F5] border border-[#00CED1] rounded-2xl space-y-2">
          <h3 className="font-display font-black text-base text-[#0A0B0D]">{t("important.securityTitle")}</h3>
          <p className="text-xs text-[#3D424B]">{t("important.securityIntro")}</p>
          <ul className="list-disc pl-5 space-y-1.5 text-xs text-[#3D424B]">
            <li><span className="font-bold text-[#0A0B0D]">{t("important.securityOneAccountLabel")}</span> {t("important.securityOneAccountText")}</li>
            <li><span className="font-bold text-[#0A0B0D]">{t("important.securityInactiveLabel")}</span> {t("important.securityInactiveText")}</li>
            <li><span className="font-bold text-[#0A0B0D]">{t("important.securityResponsibilityLabel")}</span> {t("important.securityResponsibilityText")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
